/* Copyright(c) 2019 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */
/*
@author:Priyanka Patil-5804
@Description:UI for DemandBase lead delivery
*/


import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CryptoJS from "crypto-js";

class PushData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullMessage: "",
    };
  }

  componentDidMount() {

    let length = 12;
    const bytes = Math.ceil(length / 2);  
    const hex = CryptoJS.lib.WordArray.random(bytes).toString(); 
    const requestID = hex.substring(0, length);
    // Example: API response you showed
    const response = {
      requestID: requestID,
      success: false,
      errors: [{"code":"603","message":"Access denied"}],
    };

   // Convert whole object to single-line string
    const fullText = JSON.stringify(response);

    this.setState({ fullMessage: fullText });
  }

  render() {
    return (
     <div>
       {this.state.fullMessage && (
          <div style={{ color: "black", fontWeight: "normal",fontFamily: "Consolas", whiteSpace: "nowrap" }}>
            {this.state.fullMessage}
          </div>
        )}
      </div>
    );
  }
}
export default PushData;